import React from 'react';
import { CartProvider } from '@lucid/cart';
import { getIdToken, getOrgId, getUserId } from '@lucid/auth';
import { useUserIdentity } from '@lucid/portal-core';
import { useStore } from '../../../store/store';
import Content from './Content/Content';

const CART_BASE_URL = `${import.meta.env.VITE_LUPP_BASE_URL}/importer/X`;
const CART_TENANT = import.meta.env.VITE_CART_TENANT as string;

// NOTE: Content is a separate component so it can call useCartContext()
// inside the CartProvider tree.

/**
 * Order Builder page component - allows users to build and configure new orders
 * @component
 * @returns {JSX.Element} Order Builder page
 */
const OrderBuilder: React.FC = () => {
  const theme = useStore((state) => state.theme);
  const locale = useStore((state) => state.locale);
  const { userIdentity } = useUserIdentity();
  const customerId = userIdentity?.businessOrganizationId ?? '';

  return (
    <CartProvider
      baseUrl={CART_BASE_URL}
      tenant={CART_TENANT}
      customerId={customerId}
      getAccessToken={getIdToken}
      getOrgId={getOrgId}
      getUserId={getUserId}
    >
      <Content theme={theme} locale={locale} />
    </CartProvider>
  );
};

export default OrderBuilder;
